import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentType } from "../enums/_index";
import { ShipmentActionCreate } from "./_index";
import { shipmentActionCreateMapper } from "./shipment-action-create";

export class ShipmentCreate {

    @ValidateProperty({ required: true })
    public type : ShipmentType;
    
    @ValidateProperty({ required: true })
    public name : string = '';
 
    @ValidateProperty({ required: true })
    public serviceCenterId : string = '';

    @JsonProperty({ toType: 'datetime-specific' })
    public departureTimeLocal : Date | undefined = undefined;

    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;
    
    @JsonProperty({ enumMapper: shipmentActionCreateMapper, enumProp: 'type', designType: 'array' })
    public actions : ShipmentActionCreate[] = [];

    public note : string|undefined = undefined;
}
